export interface Testimonial {
  name: string
  role: string
  location: string
  age: number
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Mark Sullivan',
    role: 'Independent Appliance Repair Technician',
    location: 'Columbus, Ohio, United States',
    age: 46,
    quote:
      'Eighteen years fixing appliances and my problem was never knowing the parts, it was the time lost digging through manuals and forums on every job. Last week a front-loader had a no-drain that the previous tech had already swapped the pump on. I followed the drain system path, checked the filter, the pump inlet and the hose route in order, and found a sock jammed at the external drain connection in ten minutes. That single call paid for the system.',
  },
  {
    name: 'Gareth Hughes',
    role: 'Field Service Engineer, appliance warranty company',
    location: 'Cardiff, United Kingdom',
    age: 39,
    quote:
      'The refrigerator and defrost pages changed how I handle not-cooling calls. Instead of condemning a board, I now check the thermistor, defrost heater and fan in a set sequence. My first-time fix rate has gone up and my reports are cleaner because I can show exactly what I tested and why.',
  },
  {
    name: 'Jason Tremblay',
    role: 'Appliance Service Technician',
    location: 'Ottawa, Ontario, Canada',
    age: 28,
    quote:
      "I'd been in the trade two years and electrical faults still made me nervous. The wiring and connector section taught me to check the connection before blaming the component. On a dryer with no heat I found a heat-damaged terminal at the element instead of ordering a new control board. My supervisor noticed I stopped calling him for help.",
  },
  {
    name: 'Brad Mitchell',
    role: 'Owner, appliance repair business',
    location: 'Adelaide, Australia',
    age: 53,
    quote:
      'I run four technicians and diagnostic time is where we lose money. Now every no-fill, no-heat and noise complaint follows the same worksheets, so handovers make sense and nothing gets tested twice. Callbacks on washing machine and dishwasher jobs have dropped noticeably. It reads like it was built by someone who has actually knelt in front of the machine.',
  },
  {
    name: 'Emma Clarke',
    role: 'Appliance Repair Trainee',
    location: 'Leicester, United Kingdom',
    age: 25,
    quote:
      'As a trainee I needed something that explains why, not just what. The water level and pressure sensing page finally made fill problems click for me, and I keep the quick reference guide open on my tablet on every call. I feel far more confident explaining the fault to customers now.',
  },
]
